import { _ } from '@ngx-translate/core';

import { ProductDialogStep } from '../../types';

export const PRODUCT_DIALOG_STEPS: Record<ProductDialogStep, string> = {
  common: _('components.loyaltyProgram.constants.productDialogStep.common'),
  contacts: _('components.loyaltyProgram.constants.productDialogStep.contacts'),
  terms: _('components.loyaltyProgram.constants.productDialogStep.terms'),
} as const;
